// Tiny dependency-free line chart for vitals trend visualisation. SVG-only,
// no chart library — keeps the patient portal bundle slim.

import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  width: 100%;
  height: ${(p) => p.$height || 80}px;
`

export default function MiniSparkline({ values, height = 80, color }) {
  if (!values || values.length === 0) return null
  if (values.length === 1) {
    return <Wrap $height={height} aria-label="single data point" />
  }
  const w = 320
  const h = height
  const padX = 4
  const padY = 6
  const min = Math.min(...values)
  const max = Math.max(...values)
  const range = max - min || 1
  const stepX = (w - padX * 2) / (values.length - 1)
  const points = values
    .map((v, i) => {
      const x = padX + i * stepX
      const y = padY + (h - padY * 2) * (1 - (v - min) / range)
      return `${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')
  const areaPath = `M ${padX},${h - padY} L ${points} L ${(w - padX).toFixed(1)},${h - padY} Z`

  return (
    <Wrap $height={height}>
      <svg
        viewBox={`0 0 ${w} ${h}`}
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        role="img"
      >
        <path d={areaPath} fill={(color || '#6B9080') + '22'} stroke="none" />
        <polyline
          points={points}
          fill="none"
          stroke={color || '#6B9080'}
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </Wrap>
  )
}
